<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Contents">
<h2 class="fmt"><span epub:type="pagebreak" id="page_vii" title="vii"><span class="cb">Contents</span></span></h2>
<p class="toc1"><a href="#/text/Foreword#rtoc1" id="toc1">Foreword</a></p>
<p class="toc1"><a href="#/text/Preface#rtoc2" id="toc2">Preface</a></p>
<p class="toc1"><a href="#/text/Acknowledgments#rtoc3" id="toc3">Acknowledgments</a></p>
<p class="toc1"><a href="#/text/Authors_Note#rtoc4" id="toc4">Authors’ Note</a></p>
<p class="toc1t"><a href="#/text/Intro#rtoc5" id="toc5">Introduction</a></p>
<p class="toc1"><a href="#/text/Chapter01#rtoc6" id="toc6">Part One: This Is What We Had</a></p>
<p class="toc1"><span href="#/text/Chapter03#rtoc7" id="toc7" title="Link target outside of Sample">Part Two: Creating a New National Network</span></p>
<p class="toc1"><span href="#/text/Chapter05#rtoc8" id="toc8" title="Link target outside of Sample">Part Three: Where Do We Go from Here?</span></p>
<p class="toc1"><span href="#/text/Chapter07#rtoc9" id="toc9" title="Link target outside of Sample">Part Four: The Road to the Future</span></p>
<p class="toc1"><span href="#/text/Epilogo#rtoc10" id="toc10" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1t"><span href="#/text/Appendix1#rtoc11" id="toc11" title="Link target outside of Sample">Appendix 1: Tracking Amtrak</span></p>
<p class="toc1"><span href="#/text/Appendix2#rtoc12" id="toc12" title="Link target outside of Sample">Appendix 2: Amtrak Presidents and US Secretaries of Transportation</span></p>
<p class="toc1"><span href="#/text/Bibliography#rtoc13" id="toc13" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/text/Index#rtoc14" id="toc14" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?ad6108ba